jQuery(function($)
{
    var
        // Pseudo-Constants
        requestUriReplacePatternPageCategory = '[pageCategory]',
        requestUriReplacePatternSearch = '[search]',
        requestUriPattern
			= '/js_catalog/'
				+ requestUriReplacePatternPageCategory
				+ '/productList/' + requestUriReplacePatternSearch,

        // module-global variables
        $body = $('body'),
        $container = $('#content'),
        idLastRequest = 0;

    if (0 === $container.length)
    {
        return;
    }

    function getRequestUri(pageCategory, search)
    {
        return requestUriPattern
            .replace(requestUriReplacePatternPageCategory, pageCategory)
            .replace(requestUriReplacePatternSearch, search);
    }

    function makeRequestPromise(pageCategory, search)
    {
        var
            requestUri = getRequestUri(pageCategory, search),
            requestId = idLastRequest + 1,

            request = $.ajax({
                'dataType': 'html',
                'url': requestUri
            });

        request.requestId = requestId;
        idLastRequest += 1;

        return request;
    }

    function reload()
    {
        console.log('reload');
        var
            pageCategory = orion.toPageCategory(),
            { search } = document.location,
            request = makeRequestPromise(pageCategory, search);

        function handleDone(markup)
        {
            if (idLastRequest !== request.requestId)
            {
                // stale request => discard
                return;
            }

            var $markup = $(markup),
                $productList = $('.product-tiles, .product-list', $container);

            $productList.empty().append($markup);
            var $productListItems = $productList.find('.js-product-list-item');

            $productListItems.css('opacity', 0).addClass('fade-in');
            window.setTimeout(function()
            {
                console.log('wait 4 .fade-in');
                $productListItems.css('opacity', 1);
                window.setTimeout(function()
                {
                    console.log('remove .fade-in');
                    $productListItems.css('opacity', '');
                    $productListItems.removeClass('fade-in');
                }, 1000);
                $container.trigger(orion.constants.EventProductListReloaded);
            }, 50);
        }

        orion.startProcessing('#custom-filter-options, .js-filter-remove-container');
        $('.product-tiles, .product-list', $container).find('.js-product-list-item')
            .addClass('fade-out');
        request
            .done(handleDone)
            .fail(function()
            {
                // console.log("…product-list request failed");
            })
            .always(function()
            {
                orion.stopProcessing('#custom-filter-options, .js-filter-remove-container');
            });
    }

    $body.on([orion.constants.EventFiltersChanged, orion.constants.EventSortCriteriumChanged].join(' '), reload);
});
